import * as React from 'react';
import {
    useNotify,
    useRecordContext,
    useTranslate,
} from 'react-admin';
import Button from '@mui/material/Button';
import { Link as RouterLink, useParams } from 'react-router-dom';
import { Card, CardContent, Box, Grid, Typography, Link } from '@mui/material';
import Totals from './Totals';
import { Ecom_Orders, Users } from "../../custom";
import "./index.css"
import Basket from './Basket';
import { goApi } from '../../services';
import { LoadingSection } from '../../common/LoadingSection';

const OrderEdit = () => {
    const { id } = useParams();
    const [record, setRecord] = React.useState<any>(null);
    const [loading, setLoading] = React.useState(true);
    const notify = useNotify();

const fetchOrder = async () => {
    try {
        const response = await goApi.get(`/ecom/orders/${id}`);
        setRecord(response.data); 

    } catch (error) {
        notify('Failed to fetch order', { type: 'error' });
    } finally {
        setLoading(false);
    }
};
    React.useEffect(() => {
        if (id) {
            fetchOrder();
        }
    }, [id]);

    const handlePrint = () => {
        window.print();
    };

    if (loading) return <LoadingSection />;

    return (
        <div>
            <div className="print-button pt-5 flex justify-end w-4/5">
                <Button onClick={handlePrint}>Print</Button>
            </div>

            <OrderForm record={record} />
        </div>
    );
};
const OrderTitle = () => {
    const translate = useTranslate();
    const record = useRecordContext<Ecom_Orders>();
    return record ? (
        <span>
            {translate('resources.orders.name', { smart_count: 1 })}
            {record.tracking_id}
        </span>
    ) : null;
};

const CustomerDetails = ({ user }: any) => {
    if (!user) return null;
    return (
        <div>
            <Typography
                component={RouterLink}
                color="primary"
                to={`/customers/${user.id}`}
                style={{ textDecoration: 'none' }}
            >
                {user.first_name} {user.last_name}
            </Typography>
            <Typography
                component={Link}
                color="primary"
                href={`mailto:${user.email}`}
                style={{ textDecoration: 'none' }}
            >
                {user.email}
            </Typography>
        </div>
    );
};

const CustomerAddressField = ({ address }: any) => {
    if (!address) return null;

    return (
        <div>
            <Typography>{address.first_name} {address.last_name}</Typography>
            <Typography>{address.phone}</Typography>
            <Typography>{address.email}</Typography>
            <Typography>{address.address_line}</Typography>
            <Typography>{address.landmark}</Typography>
            <Typography>
                {address.locality}, {address.city}, {address.district}
            </Typography>
            <Typography>{address.pincode}</Typography>
            <Typography>{address.state}</Typography>
        </div>
    );
};
const Spacer = () => <Box m={1}>&nbsp;</Box>;

const OrderForm = ({ record }: any) => {
    if (!record) return null;

    return (
        <Box id="printt" className="print-only">
            <Card>
                <CardContent className='w-[50vw]'>

                    <Typography variant="h6">Order</Typography>
                    <Typography>
                         {record.status || "UNKNOWN"}
                    </Typography>
                    <Spacer />

                    <Typography variant="h6">Student</Typography>
                    <CustomerDetails user={record.user} />

                    <Spacer />

                    <Typography variant="h6">Address</Typography>
                    <CustomerAddressField address={record.address} />

                    <Spacer />

                    <Typography variant="h6">Order Items</Typography>
                    <Basket record={record} />

                    <Spacer />

                    <Typography variant="h6">Total</Typography>
                    <Totals record={record} />

                </CardContent>
            </Card>
        </Box>
    );
};

export default OrderEdit;